import elasticlunr from "elasticlunr";

import iconDataJson from "./icons.json";

interface IconRecord {
    name: string;
    tags: string;
    key: string;
}

interface IconData {
    [key: string]: IconRecord;
}

export const iconData: IconData = iconDataJson;

// Historically, we've been using our icons off the staging bucket,
// this should be refactored in the future so we have independent icons
// stored for every environment
export const baseUrl = "https://storage.googleapis.com/beautiful-icons-staging";

let searchIndex: elasticlunr.Index<IconRecord>;
function getSearchIndex() {
    if (!searchIndex) {
        searchIndex = elasticlunr<IconRecord>(function config() {
            this.addField("name");
            this.addField("tags");
            this.setRef("key");
        });
        Object.values(iconData).forEach(doc => {
            searchIndex.addDoc(doc);
        });
    }

    return searchIndex;
}

export function iconSearch(rawInput: string) {
    const searchIndex = getSearchIndex();

    const query = rawInput.toLowerCase().trim();
    if (query.length === 0) {
        return { results: [], query };
    }

    let results = searchIndex.search(query, {
        bool: "AND",
        expand: true
    });
    if (results.length === 0) {
        results = searchIndex.search(query, {
            bool: "OR",
            expand: true
        });
    }
    if (results.length === 0) {
        results = searchIndex.search(query.split(" ")[0], {
            bool: "OR",
            expand: true
        });
    }

    return { results, query };
}
